import React from 'react'

const RealTimeMonitorComponentLoadable = React.lazy(() => import('./RealtimeMonitorComponent'))
const DeviceConfigComponentLoadable = React.lazy(() => import('./DeviceConfigComponent'))
const DeviceHistoryComponentLoadable = React.lazy(() => import('./DeviceHistoryComponent'))

export {
	RealTimeMonitorComponentLoadable,
	DeviceHistoryComponentLoadable,
	DeviceConfigComponentLoadable
}